import {$,w} from './constants';

export function tableControls() {

	// Activate search mode
	$('.table_JS').addClass('active')
	$('.table_row_JS').removeClass('hide')

	var searchPin = 0
	var fail = 0

	// Evaluate text input
	var searchText = $('.table_search_JS').val().toLowerCase()
	if (searchText != '') {
		searchPin++
		$('.td_name_JS').each(function () {
			var name = $(this).text().toLowerCase()
			if (!name.includes(searchText)) {
				$(this).closest('.table_row_JS').addClass('hide')
			}
		})
	}

	// Evaluate select inputs
	$('.table_select_JS').each(function () {
		var searchVal = $(this).val().toLowerCase()
		var searchID = $(this).attr('id')
		if (searchVal != '') {
			$('.table_row_JS:not(.hide)').each(function () {
				var row = $(this).data(searchID).toLowerCase()
				if (row != searchVal) {
					$(this).addClass('hide')
				}
			})
			searchPin++
		}
	})

	if (searchPin == 0) {
		$('.table_JS').removeClass('active')
		$('.table_row_JS').removeClass('hide')
	}
}

// Input search trigger
$('.table_search_JS').on('input', function() {
	tableControls()
})

// Select search trigger
$('.table_select_JS').on('change', function() {
	tableControls()
})

// Term filtering via buttons
$('.table_btn_JS').click(function () {

	// Reset all rows
	$('.table_JS').removeClass('active')
	$('.table_row_JS').addClass('hide')

	// Filter rows by type
	var type = $(this).data('type')
	console.log(type)
	$('.table_JS').addClass('active')
	$('.table_select_JS#type').val(type)
	$('.table_row_JS').each(function () {
		console.log($(this).data('type'))
		if ($(this).data('type') == type) {
			$(this).removeClass('hide')
		}
	})

	// Scroll to table
	$('html,body').animate({
		scrollTop: $('.table_anchor_JS').offset().top
	}, 300)

})

